import {Component} from 'react';
import axios from "axios"
import Nav from "./Nav";
import Swal from "sweetalert2";
import myconfig from "../myconfig";
import $ from 'jquery';
import { Modal,Button } from 'react-bootstrap';

let source = axios.CancelToken.source();

class Report extends Component {
    constructor() {
        super();
        this.state = {
            menu: 'g-sidenav-show bg-gray-100',
            clubs:[],
            orginalplayers:[],
            filterplayers:[],
            clubfilter:'all',
            typefilter:'all',
            txtfilter:'',
        }
    }

    async componentDidMount() {
        let baseurl = myconfig.getclub;
        await axios.post(baseurl, {}, {cancelToken: source.token}).then(res => {
            console.log(res.data)
            if (res.data.success == false) {
                Swal.fire({
                    title: 'Error!',
                    text: res.data.message,
                    icon: 'error',
                    confirmButtonText: 'Okay'
                })
            } else {
                this.setState({
                    clubs:res.data.datas
                })
            }
        }).catch((e) => {
            console.log(e.message);
        });
        baseurl=myconfig.getplayer
        await axios.post(baseurl, {}, {cancelToken: source.token}).then(res => {
            console.log(res.data)
            if (res.data.success == false) {
                Swal.fire({
                    title: 'Error!',
                    text: res.data.message,
                    icon: 'error',
                    confirmButtonText: 'Okay'
                })
            } else {
                console.log(res.data.datas)
                this.setState({
                    orginalplayers:res.data.datas,
                    filterplayers:res.data.datas,
                })
            }
        }).catch((e) => {
            console.log(e.message);
        });
    }

    componentWillUnmount() {
        try {
            if (source) {
                source.cancel("Landing Component got unmounted");
            }
        } catch (e) {

        }
    }

    menuhidden = (event) => {
        event.preventDefault();
        if (this.state.menu == "g-sidenav-show bg-gray-100")
            this.setState({
                menu: "g-sidenav-hidden bg-gray-100"
            })
        else
            this.setState({
                menu: "g-sidenav-show bg-gray-100"
            })
    }
    inputmgt = (event) => {
        event.preventDefault();
        var name = event.target.name;
        var value = event.target.value;
        this.setState({
            [name]: value,
        },()=>this.filterbyCat())
    }
    inputmgttxt= (event) => {
        event.preventDefault();
        var name = event.target.name;
        var value = event.target.value;
        this.setState({
            [name]: value,
        },()=>this.filterbyText())
    }
    clubcat=()=> {
        let options=this.state.clubs.map(value => {
            return (<option value={value.id}>{value.name}</option>)
        })
        return (<>
            <label>
                <select name="clubfilter" value={this.state.clubfilter} onChange={this.inputmgt} className="dataTable-selector">
                    <option value="all">All</option>
                    {options}
                </select> select project
            </label>
        </>)
    }
    playerdata=()=> {
        let count=0
        let tabledata=this.state.filterplayers.map(value => {
            count=count+1;
            let c="";
            if(value.status=="Not-Eligible")
                c="hazared"
            return(<>
                <tr className={c}>
                    <td data-sortable>
                        {count}
                    </td>
                    <td data-sortable>
                        <img className="w-100" style={{width:"100% !important"}}
                             src={value.imgdata}
                             alt="mac"/>
                    </td>
                    <td data-sortable>
                        {value.club_name}
                    </td>
                    <td data-sortable>
                        {value.player_id}
                    </td>
                    <td data-sortable>
                        {value.name}
                    </td>
                    <td data-sortable>
                        {value.sex}
                    </td>
                    <td data-sortable>
                        {value.type}
                    </td>
                    <td data-sortable>
                        {value.status}
                    </td>
                    <td data-sortable>
                        {value.height} cm
                    </td>
                    <td data-sortable>
                        {value.weight} kg
                    </td>
                    <td data-sortable>
                        {value.postion}
                    </td>
                    <td data-sortable>
                        {value.leg}
                    </td>
                </tr>
            </>)
        })
        return (<>
            <div className="table-responsive">
                <div
                    className="dataTable-wrapper dataTable-loading no-footer sortable searchable fixed-columns">
                    <div className="dataTable-top">
                        <div className="dataTable-dropdown">
                            {this.clubcat()}
                        </div>
                        <div className="dataTable-search">
                            <input name="txtfilter" value={this.state.txtfilter} onChange={this.inputmgttxt} className="dataTable-input" placeholder="Search..." type="text"/>
                        </div>
                    </div>
                    <div className="dataTable-top">
                        <div className="dataTable-dropdown">
                            <label>
                                <select  name="typefilter" value={this.state.typefilter} onChange={this.inputmgt}  className="dataTable-selector">
                                    <option value="all">All</option>
                                    <option value="U-20">U-20</option>
                                    <option value="U-23">U-23</option>
                                </select>
                                select categories
                            </label>
                        </div>
                    </div>
                    <div className="dataTable-container  overflow-auto" style={{height: '400px'}}>
                        <table className="table table-flush dataTable-table"
                               id="products-list">
                            <thead className="thead-light">
                            <tr>
                                <th>
                                    #
                                </th>
                                <th style={{width:"20%"}}>
                                    Photo
                                </th>
                                <th data-sortable>
                                    <a href="#" className="dataTable-sorter">
                                        Project Name
                                    </a>
                                </th>
                                <th data-sortable>
                                    <a href="#" className="dataTable-sorter">
                                        Player ID
                                    </a>
                                </th>
                                <th data-sortable>
                                    <a href="#" className="dataTable-sorter">
                                        Player Name
                                    </a>
                                </th>
                                <th data-sortable>
                                    <a href="#" className="dataTable-sorter">
                                        Sex
                                    </a>
                                </th>
                                <th data-sortable>
                                    <a href="#" className="dataTable-sorter">
                                        Type
                                    </a>
                                </th>
                                <th data-sortable>
                                    <a href="#" className="dataTable-sorter">
                                        Status
                                    </a>
                                </th>
                                <th data-sortable>
                                    <a href="#" className="dataTable-sorter">
                                        Height
                                    </a>
                                </th>
                                <th data-sortable>
                                    <a href="#" className="dataTable-sorter">
                                        Weight
                                    </a>
                                </th>
                                <th data-sortable>
                                    <a href="#" className="dataTable-sorter">
                                        Position
                                    </a>
                                </th>
                                <th data-sortable>
                                    <a href="#" className="dataTable-sorter">
                                        Leg
                                    </a>
                                </th>

                            </tr>
                            </thead>
                            <tbody>
                            {tabledata}
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
        </>)
    }

    filterbyCat=()=>{
        let temp=this.state.orginalplayers;
        if(this.state.clubfilter!="all"){
            temp=temp.filter(value => {
                if(value.club_id==this.state.clubfilter)
                    return value;
            })
        }
        if(this.state.typefilter!="all"){
            temp=temp.filter(value => {
                if(value.type==this.state.typefilter)
                    return value;
            })
        }
        this.setState({
            filterplayers: temp,
        })
    }
    filterbyText=()=> {
        let temp = this.state.orginalplayers;
        if (this.state.txtfilter == "")
            this.filterbyCat()
        else {
            temp = temp.filter(value => {
                console.log(value.name)
                if (
                    value.name.toUpperCase().includes(this.state.txtfilter.toUpperCase())||
                    value.player_id.toUpperCase().includes(this.state.txtfilter.toUpperCase())
                )
                    return value;
            })
            this.setState({
                filterplayers: temp,
            })
        }
    }
    render() {
        return (
            <>
                <div className={this.state.menu}>
                    <Nav/>
                    <main className="main-content position-relative border-radius-lg ">
                        {/* Navbar */}
                        <nav
                            className="navbar navbar-main navbar-expand-lg  px-0 mx-4 shadow-none border-radius-xl z-index-sticky "
                            id="navbarBlur" data-scroll="false">
                            <div className="container-fluid py-1 px-3">
                                <nav aria-label="breadcrumb">
                                    <ol className="breadcrumb bg-transparent mb-0 pb-0 pt-1 px-0 me-sm-6 me-5">
                                        <li className="breadcrumb-item text-sm">
                                            <a className="text-white" href="#">
                                                <i className="ni ni-box-2"/>
                                            </a>
                                        </li>
                                        <li className="breadcrumb-item text-sm text-white"><a
                                            className="opacity-5 text-white" href="#">Dashboard</a></li>
                                    </ol>
                                    <h6 className="font-weight-bolder mb-0 text-white">Dashboard-1</h6>
                                </nav>
                                <div className="sidenav-toggler sidenav-toggler-inner d-xl-block d-none ">
                                    <a href="#" onClick={this.menuhidden} className="nav-link p-0">
                                        <div className="sidenav-toggler-inner">
                                            <i className="sidenav-toggler-line bg-white"/>
                                            <i className="sidenav-toggler-line bg-white"/>
                                            <i className="sidenav-toggler-line bg-white"/>
                                        </div>
                                    </a>
                                </div>
                                <div className="collapse navbar-collapse mt-sm-0 mt-2 me-md-0 me-sm-4" id="navbar">
                                    <div className="ms-md-auto pe-md-3 d-flex align-items-center">
                                        <div className="input-group">
                                            <span className="input-group-text text-body"><i className="fas fa-search"
                                                                                            aria-hidden="true"/></span>
                                            <input type="text" className="form-control" placeholder="Type here..."/>
                                        </div>
                                    </div>
                                    <ul className="navbar-nav  justify-content-end">
                                        <li className="nav-item d-flex align-items-center">
                                            <a href="../../pages/authentication/signin/illustration.html"
                                               className="nav-link text-white font-weight-bold px-0" target="_blank">
                                                <i className="fa fa-user me-sm-1"/>
                                                <span className="d-sm-inline d-none">Sign In</span>
                                            </a>
                                        </li>
                                        <li className="nav-item d-xl-none ps-3 d-flex align-items-center">
                                            <a href="#" className="nav-link text-white p-0" id="iconNavbarSidenav">
                                                <div className="sidenav-toggler-inner">
                                                    <i className="sidenav-toggler-line bg-white"/>
                                                    <i className="sidenav-toggler-line bg-white"/>
                                                    <i className="sidenav-toggler-line bg-white"/>
                                                </div>
                                            </a>
                                        </li>
                                    </ul>
                                </div>
                            </div>
                        </nav>
                        {/* End Navbar */}
                        <div className="container-fluid py-4">
                            <div className="row">
                                <div className="col-12">
                                    <div className="card">
                                        {/* Card header */}
                                        <div className="card-header pb-0">
                                            <div className="d-lg-flex">
                                                <div>
                                                    <h5 className="mb-0">Player datas</h5>
                                                    <p className="text-sm mb-0">
                                                        Here you can find all player data that are registered in U-20 and U-23 category's
                                                    </p>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="card-body px-0 pb-0">
                                            {this.playerdata()}
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <footer className="footer pt-3  ">
                                <div className="container-fluid">
                                    <div className="row align-items-center justify-content-lg-between">
                                        <div className="col-lg-6 mb-lg-0 mb-4">
                                            <div className="copyright text-center text-sm text-muted text-lg-start">
                                                © 2022,
                                                made with <i className="fa fa-heart" aria-hidden="true"/> by
                                                <a href="#" className="font-weight-bold"> ZTS Ethiopia</a>
                                            </div>
                                        </div>
                                        <div className="col-lg-6">
                                            <ul className="nav nav-footer justify-content-center justify-content-lg-end">
                                                <li className="nav-item">
                                                    <a href="#"
                                                       className="nav-link text-muted">ZTS Ethiopia</a>
                                                </li>
                                                <li className="nav-item">
                                                    <a href="#"
                                                       className="nav-link text-muted">About Us</a>
                                                </li>
                                                <li className="nav-item">
                                                    <a href="#"
                                                       className="nav-link pe-0 text-muted">License</a>
                                                </li>
                                            </ul>
                                        </div>
                                    </div>
                                </div>
                            </footer>
                        </div>
                    </main>
                </div>
            </>
        )
    }
}

export default Report;
